/** Cache keys for workspace usage reads. */
export const usageKeys = {
  all: ['usage'] as const,
  /**
   * One workspace's period. The period is part of the key so stepping between months
   * caches each rather than refetching a month the reader already looked at, and so a
   * mutation elsewhere can invalidate one period without discarding the rest.
   */
  workspace: (workspaceId: string, period: string | undefined) =>
    ['usage', 'workspace', workspaceId, period ?? 'current'] as const,
  /**
   * The same period's spend by workflow, profile and connection (spec 225). Under the
   * workspace's key, so whatever invalidates the usage figures invalidates these too
   * and the two never show different periods' worth of runs.
   */
  spendGroups: (workspaceId: string, period: string | undefined) =>
    ['usage', 'workspace', workspaceId, period ?? 'current', 'groups'] as const,
  organization: (period: string | undefined) =>
    ['usage', 'organization', period ?? 'current'] as const,
};
